import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=06b43802&scoped=true&"
import script from "./colors.vue?vue&type=script&lang=js&"
export * from "./colors.vue?vue&type=script&lang=js&"
import style0 from "./colors.vue?vue&type=style&index=0&id=06b43802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b43802",
  null
  
)

export default component.exports